import React from 'react'
import styled from 'styled-components'
import { SettingsConsumer } from 'contexts/settings-context'
import { themes } from 'contexts/theme-context'

const Wrapper = styled.div`
  display: flex;
  height: 198px;
`

const ItemsList = styled.ul`
  display: flex;
  justify-content: center;
  flex-flow: row;
  flex-wrap: wrap;
  max-width: 820px;
  margin: 46px auto;
`

const LogoWrapper = styled.li`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px;
`

function DesktopLogos(props) {
  const themesToRender = Object.keys(themes).filter((theme) => themes[theme].showInNetworkNav === true)
  return (
    <SettingsConsumer>
      {(settings) => {
        return (
          <Wrapper>
            <ItemsList>
              {themesToRender.map((themeName, index) => {
                const theme = themes[themeName]
                const logo = theme.footerLogoItems.desktopLogo
                return (
                  logo && (
                    <LogoWrapper key={`Desktop-footer-logos-${index}-${themeName}`}>
                      <a href={logo.url}>
                        <img src={`${settings.HOSTNAME}${logo.image}`} width={logo.width} alt={theme.displayName} />
                      </a>
                    </LogoWrapper>
                  )
                )
              })}
            </ItemsList>
          </Wrapper>
        )
      }}
    </SettingsConsumer>
  )
}

export default DesktopLogos



// WEBPACK FOOTER //
// ./src/organisms/Footer/components/DesktopLogos.js